import { useState, type ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";
import {
  readOperatingFront,
  writeOperatingFront,
  type OperatingFrontId,
} from "@/lib/operatingFront";
import { OperatingFrontContext } from "./operatingFrontContext";
import { OperatingFrontPicker } from "./OperatingFrontScreens";
import { SalesDesk } from "./salesDesk/SalesDesk";

export function OperatingFrontGate({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const userId = auth.session?.user?.id ?? "local";
  const [front, setFront] = useState<OperatingFrontId | null>(() => readOperatingFront(userId));

  const choose = (id: OperatingFrontId) => {
    writeOperatingFront(userId, id);
    setFront(id);
  };

  const returnToPicker = () => {
    writeOperatingFront(userId, null);
    setFront(null);
  };

  if (!front) return <OperatingFrontPicker onChoose={choose} />;

  return (
    <OperatingFrontContext.Provider value={{ returnToPicker }}>
      {front === "sales" ? <SalesDesk /> : children}
    </OperatingFrontContext.Provider>
  );
}
